import { RowSelectionState } from '@tanstack/react-table';

interface UseGlobalApplyTagsOptions<T> {
  rowSelection: RowSelectionState;
  entities: T[];
  selectedSchemaId: string;
  handleApplyTags: (args: {
    entities: T[];
    newTags: string[];
    isManaged: boolean;
    schemaId: string;
  }) => Promise<void>;
  getEntityId: (entity: T) => string;
}

export const useGlobalApplyTags = <T>({
  rowSelection,
  entities,
  selectedSchemaId,
  handleApplyTags,
  getEntityId,
}: UseGlobalApplyTagsOptions<T>) => {
  const handleGlobalApplyTags = async (
    newTags: string[],
    isManaged: boolean,
  ) => {
    const selectedIdentifiers = Object.keys(rowSelection);
    const selectedEntities = entities.reduce<T[]>((acc, entity) => {
      if (selectedIdentifiers.includes(getEntityId(entity))) {
        acc.push(entity);
      }
      return acc;
    }, []);

    await handleApplyTags({
      entities: selectedEntities,
      newTags,
      isManaged,
      schemaId: selectedSchemaId,
    });
  };

  return handleGlobalApplyTags;
};
